import { useMemo } from 'react'
import { useElementSize } from '@mote/helpers/hooks'
import type { MoteCardConfigOptions } from './getMoteCardConfig'
import { getMoteCardConfig } from './getMoteCardConfig'

export const useMoteCardConfig = (options: MoteCardConfigOptions) => {
  const { ref, width, height } = useElementSize<HTMLDivElement>({
    box: 'border-box'
  })
  const config = useMemo(
    () => getMoteCardConfig(width, options),
    [width, options]
  )
  return {
    ref,
    config,
    width,
    height
  }
}
